module.exports = __webpack_public_path__ + "fj.svg?55c3d3a6d0de0ad52441986bc1a0daee";